import {
  getDatasetOrderedByWeekAndYear,
  getDataset,
} from "api/dataVisualisation/client";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import { DataDownloadModel } from "models/dataDownload/dataDownloadModel";
import { GenerationForecastDownloadDataModel } from "models/generationForecast/generationForecastDownloadModels/generationForecastDownloadDataModel";

export const getGenerationForecast14DayUOUDownloadData = async (
  format: DataDownloadFormat
): Promise<DataDownloadModel<GenerationForecastDownloadDataModel>> =>
  getDataset<GenerationForecastDownloadDataModel>(format, "UOU2T14D");

export const getGenerationForecast3YearUOUDownloadData = async (
  format: DataDownloadFormat
): Promise<DataDownloadModel<GenerationForecastDownloadDataModel>> =>
  getDatasetOrderedByWeekAndYear<GenerationForecastDownloadDataModel>(
    format,
    "UOU2T3YW"
  );
